import Vue from 'vue/dist/vue.js';

let bioCard = Vue.component('bio-card', {
    props: ['person'],
    template: `<div class="col-span-3 text-gray">
        <div class="bio-card text-current text-left">
            <a :href="person.rawLink" class="inline-block w-full no-icon p-3 -m-3 bg-transparent global--transition-colors text-gray no-underline hover:text-white hover:bg-dark focus:text-white focus:bg-dark focus:outline group-hover:text-white group-focus:text-white group-focus:bg-dark group-focus:outline">
                <div class="w-full aspect-square mb-6">
                     <img v-if="person.featured_image.sizes.bio_thumbnail"
                        :src="person.featured_image.base_path+person.featured_image.sizes.bio_thumbnail.file"
                        :srcset="getSrcSet( person.featured_image )"
                        :alt="person.featured_image.alt"
                        :width="person.featured_image.sizes.bio_thumbnail.width"
                        :height="person.featured_image.sizes.bio_thumbnail.height"
                        class="w-full h-full object-cover rounded-full lazy"
                        lazyload
                    >
                    <template v-else>
                        <img width="284" height="284" class="w-full h-full bg-gray object-cover rounded-full"/>
                    </template>
                </div>
                <div class="text--h6 mb-6" v-html="person.category[0].name"></div>

                <div class="text--h4 mb-px text-white" v-if="person.first_name && person.last_name">
                    {{ person.first_name }} <span v-if="person.middle_name_initial">{{ person.middle_name_initial }}.</span> {{ person.last_name }}
                </div>
                <div class="text--h4 mb-px text-white" v-else-if="person.first_name">
                    {{ person.first_name }} <span v-if="person.middle_name_initial">{{ person.middle_name_initial }}.</span>
                </div>

                <div class="text--h6 text-white" v-if="person.area_of_expertise_or_role">
                    {{ person.area_of_expertise_or_role }}
                </div>
            </a>
        </div>
    </div>`,
    methods: {
        getSrcSet: function( obj ) {
            let scrset_string = '';

            // console.log('\n0');
            // console.log('a: ', typeof obj.sizes.bio_thumbnail);
            // console.log('b: ', typeof obj.sizes['bio_large_thumbnail@2x']);

            if(typeof obj.sizes.bio_thumbnail !== 'undefined'){
                // console.log('obj.sizes.bio_thumbnail is ', obj.sizes.bio_thumbnail);

                scrset_string += obj.base_path + obj.sizes.bio_thumbnail.file+' 1x';
            }

            if(typeof obj.sizes['bio_large_thumbnail@2x'] !== 'undefined'){
                // console.log('obj.sizes.bio_large_thumbnail is ', obj.sizes['bio_large_thumbnail@2x']);

                scrset_string += ', ' + obj.base_path + obj.sizes['bio_large_thumbnail@2x'].file+' 2x';
            }

            return scrset_string;
        },
    }
});

export default {
    components: { bioCard }
}